export enum SurveyPollType {
  ACTIVE_POLLS = 'active_polls',
  MY_POLLS = 'my_polls',
  COMPLETED_POLLS = 'completed_polls',
}

export enum SurveyOptions {
  SingleChoice = 0,
  MultipleChoice = 1,
}

export enum SurveyType {
  Group = 'group',
  Club = 'all_club',
}

export enum SurveyViewOption {
  Always = 0,
  AfterVoting = 1,
  Never = 2,
}

export enum SurveyNotificationOption {
  WebNotification = 1,
  EmailNotification = 2,
}
